<template>
  <div class="resultList">
    <div v-for="(item, i) in result.lists" :key="i" class="resultList__item">
      <div class="resultList__body" @click="toggleOpen(i)">
        <h3 class="resultList__title">{{ item.title }}</h3>
        <p
          class="resultList__text"
          :class="{'resultList__text--open': isOpen[i]}"
          v-html="item.text"
        ></p>
        <linkIcon
          v-if="!isGetters"
          class="resultList__icon"
          :icon-type="iconType"
          :is-opened="isOpen[i]"
          :is-playlist-text-menu="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { SEC_ICON_TYPE } from '@/CONSTS/MENUS.js'
import linkIcon from "@/utvStore/components/partials/LinkIcon";

export default {
  name: "resultList",
  components: {
    linkIcon,
  },
  data() {
    return {
      iconType: SEC_ICON_TYPE.text,
      // 結果の各サブメニューがオープンかどうかの配列
      isOpen: [],
      // ゲッターズ？
      isGetters: this.result.counselor.menu_id == '6007' ? true : false,
    }
  },
  props: {
    result: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {
    // 結果の各サブメニューの数だけ、isOpen に false
    this.result.lists.forEach(() => {
      if (this.isGetters) {
        this.isOpen.push(true)
      } else {
        this.isOpen.push(false)
      }
    });
  },
  methods: {
    // サブメニューの開閉
    toggleOpen (index) {
      if (this.isGetters) return false
      this.isOpen.splice(index, 1, !this.isOpen[index])
    }
  }
}
</script>

<style scoped lang="scss">
.resultList {
  &__item {
    border-bottom: 1px solid #EDEDED;
  }
  &__body {
    overflow: hidden;
    padding: 24px 0 16px;
  }
  &__title {
    margin: 0 0 8px;
    font-weight: bold;
    font-size: 17px;
    line-height: 25px;
    color: #32373F;
  }
  &__text {
    font-weight: normal;
    font-size: 13px;
    line-height: 21px;
    text-align: justify;
    color: #656D78;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    &--open {
      display: block;
    }
  }
  &__icon {
    float: right;
  }
}
</style>

<style lang="scss">
.resultList {
  &__text {
    br,
    img { display: none !important;}
    &--open {
      br,
      img { display: block !important;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/resultList.vue